import styled from "styled-components"

import { when, maxWidth } from "utils"

import CloudinaryImage from "components/cloudinary-image"

export const Card = styled.div`
  background: #f6f6f6;
  display: ${({ hideOnPageLoad }) => (hideOnPageLoad ? "none" : "flex")};
  flex-direction: column;
  padding: 3rem 4.4rem;
  color: ${(props) => props.theme.colors.text.primary};
  border-radius: 0.6rem;

  ${(props) =>
    props.theme.component.isDarkBackground &&
    `
    background: #fff;
  `}
`

export const Text = styled.blockquote`
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;

  p {
    flex: 1 0 auto;
    font-size: 2.3rem;
    line-height: 3.1rem;
  }

  p::before {
    content: "“";
  }

  p::after {
    content: "”";
  }
`

export const Attribution = styled.div`
  font-size: 2rem;
  line-height: 2.6rem;
  font-weight: 500;

  span.attribSmall {
    font-size: 1.6rem;
  }
`

export const Product = styled.div`
  display: flex;
  align-items: center;

  h4 {
    font-size: 1.8rem;
    line-height: 2.1rem;
  }

  h5 {
    font-size: 1.5rem;
    line-height: 2.1rem;
  }
`

export const ProductImage = styled(CloudinaryImage)`
  width: 4.8rem;
  height: 4.8rem;
  margin-right: 1rem;
  flex-shrink: 0;

  img {
    border-radius: 50%;
  }
`

export const CelebrityCard = styled.div`
  display: ${({ hideOnPageLoad }) => (hideOnPageLoad ? "none" : "flex")};
  flex-direction: column;

  ${when("standalone")`
    margin: 2rem;
  `}

  h2 {
    color: ${({ theme }) => theme.component.largeHeading};
    font-size: 2.8rem;
    line-height: 3.8rem;
    min-height: 10rem;

    ${maxWidth.mobile`
      min-height: 0;
      margin-bottom: 1rem;
    `}

    strong,
    em {
      color: ${(props) => props.theme.component.highlight};
      font-style: inherit;
    }
  }

  h2::before {
    content: "“";
  }

  h2::after {
    content: "”";
  }

  h3 {
    font-size: 2.6rem;
    line-height: 4.6rem;
    color: #767676;
  }

  h4 {
    font-size: 1.4rem;
    line-height: 1.9rem;
    text-transform: uppercase;
    color: #767676;
  }

  p {
    font-size: 1.6rem;
    line-height: 2.1rem;
  }

  p::before {
    content: "“";
  }

  p::after {
    content: "”";
  }
`

export const CelebrityImage = styled(CloudinaryImage)`
  padding-bottom: calc(233 / 350 * 100%);
  margin-bottom: 1.5rem;

  img {
    border-bottom: 0.4rem solid #e8e4e4;
  }
`
